import { SHOW_MODAL, HIDE_MODAL } from '../actions/types'

export const loadModal = (modalType, contentData) => {
  return {
    type: SHOW_MODAL,
    modalType,
    contentData,
  }
}

export const hideModal = () => {
  return {
    type: HIDE_MODAL,
  }
}



// WEBPACK FOOTER //
// ./src/actions/modal.js